<div>
  <div class="d-flex align-items-center justify-content-between mb-2">
    <p class="heading m-0">Brand Scheduler Report</p>
    <button
      type="button"
      class="btn btn-sm btn-outline-primary"
      [disabled]="downloadLoading"
      (click)="downloadReport()"
    >
      {{ downloadLoading ? 'Downloading...' : 'Download XLS' }}
    </button>
  </div>

  <div class="widget-subtitle mb-2">
    Filter by brand and date range to preview and download scheduler execution report.
  </div>

  <div class="row no-gutters mb-2">
    <div class="col-md-3 pr-2">
      <label class="filter-label">Brand</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedBrandName">
        <option value="" disabled>Select brand</option>
        <option *ngFor="let brand of brandList" [value]="brand.brandName">
          {{ brand.brandName }}
        </option>
      </select>
    </div>

    <div class="col-md-2 pr-2">
      <label class="filter-label">From</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" />
    </div>

    <div class="col-md-2 pr-2">
      <label class="filter-label">To</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" />
    </div>

    <div class="col-md-3 pr-2">
      <label class="filter-label">Build Name (optional)</label>
      <input
        type="text"
        class="form-control form-control-sm"
        placeholder="Enter build name"
        [(ngModel)]="buildName"
      />
    </div>

    <div class="col-md-2 d-flex align-items-end">
      <button type="button" class="btn btn-sm btn-primary w-100" [disabled]="loading" (click)="fetchReport()">
        {{ loading ? 'Loading...' : 'View' }}
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-msg mb-2">{{ errorMessage }}</div>

  <div class="table-responsive" *ngIf="!loading">
    <table class="table table-sm table-striped table-bordered m-0" *ngIf="reportRows.length > 0">
      <thead>
        <tr>
          <th>Date</th>
          <th>Job Name</th>
          <th>History Id</th>
          <th>Platform</th>
          <th>Pass</th>
          <th>Fail</th>
          <th>Skip</th>
          <th>Total</th>
          <th>Build</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of reportRows">
          <td>{{ row.executionDate }}</td>
          <td>{{ row.jobName }}</td>
          <td>{{ row.exeHistoryId }}</td>
          <td>{{ row.platformName }}</td>
          <td class="pass-text">{{ row.schedulerPassCount }}</td>
          <td class="fail-text">{{ row.schedulerFailCount }}</td>
          <td class="skip-text">{{ row.schedulerSkipCount }}</td>
          <td>{{ row.schedulerTotalCases }}</td>
          <td>{{ row.appVersion }}</td>
        </tr>
      </tbody>
    </table>

    <div class="no-record" *ngIf="reportRows.length === 0 && !errorMessage">
      No report rows found for selected filter.
    </div>
  </div>
</div>
